module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/childcare-mobile-bd01bc93322e75744936e9629482a048.jpg";